import { PROGRESS_BAR_COLORS } from 'views/Protocol/updateForm/components/ModalSLAInfo/utils';

export const getProgressBarColor = (percentage) => {
  if (percentage >= 75) {
    return PROGRESS_BAR_COLORS.VALUE_100;
  } else if (percentage >= 50) {
    return PROGRESS_BAR_COLORS.VALUE_75;
  } else if (percentage >= 25) {
    return PROGRESS_BAR_COLORS.VALUE_50;
  } else {
    return PROGRESS_BAR_COLORS.VALUE_25;
  }
};
